//library
import { makeStyles } from "@mui/styles";

/**
 * The theme object to style MaterialUI components
 */
const useStyles = makeStyles(() => ({
	content: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		flexDirection: "column",
		paddingTop: 30,
	},
	logout: {
		color: "#780000",
	},
	logoutRow: {
		display: "flex",
		width: "90%",
		justifyContent: "flex-end",
	},
	row: {
		"&:hover": {
			backgroundColor: "rgba(224, 224, 224, 0.2)",
			transition: "ease-in-out",
		},
	},
	headings: {
		color: "black",
		width: "100%",
		display: "flex",
		flexDirection: "row",
		justifyContent: "center",
		alignItems: "center",
		textAlign: "center",
	},
	card: {
		display: "flex",
		overflowX: "scroll",
		whiteSpace: "nowrap",
		flexDirection: "column",
		width: "100%",
		alignItems: "center",
		justifyContent: "center",
		marginTop: 5,
		marginBottom: 15,
		gap: 10,
	},
	success: {
		color: "green",
		textTransform: "capitalize",
	},
	pending: {
		color: "orange",
		textTransform: "capitalize",
	},
	declined: {
		color: "red",
		textTransform: "capitalize",
	},
	manualOverrideBox: {
		maxHeight: 500,
		width: 720,
		padding: 10,
	},
	dialogHeader: {
		textAlign: "center",
		padding: 10,
	},
	updateManualOverrideRow: {
		width: 500,
	},
	boldText: {
		fontWeight: "bold",
	},
	manualOverrideSelection: {
		textAlign: "center",
		cursor: "pointer",
	},
}));

export default useStyles;
